module.exports = __webpack_public_path__ + "static/img/icon-head.9438887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-head.jpg
// module id = aM34
// module chunks = 21